var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-navbar-brand',{attrs:{"href":"#"}},[_c('b',{staticClass:"logo-icon"},[(_vm.LayoutType !== 'mini-sidebar')?_c('img',{attrs:{"src":require("../../../assets/images/logo-softbusiness.png"),"alt":"homepage","height":"55rem"}}):_c('img',{attrs:{"src":require("../../../assets/images/logo-mini-blue.png"),"alt":"homepage","height":"50rem"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }